// A regra do botao VOLTAR mora aqui, fora do componente, por dois motivos:
// da para testar sem montar tela, e o Layout e um lugar so -- toda rota funda
// ganha voltar de uma vez, inclusive as que ainda nem existem.

// As cinco abas da navegacao de baixo. Delas nao se "volta": ja sao o chao.
// Produtos e Representadas SAIRAM da barra em 08/08, quando a Agenda entrou e
// elas foram para a pagina Mais: viraram telas fundas e ganharam o voltar de
// graca, sem uma linha de codigo a mais em nenhuma das duas.
export const RAIZES = ['/', '/agenda', '/clientes', '/pedidos', '/mais'] as const

function semBarraNoFim(caminho: string): string {
  return caminho.length > 1 && caminho.endsWith('/') ? caminho.slice(0, -1) : caminho
}

export function mostraVoltar(caminho: string): boolean {
  return !RAIZES.includes(semBarraNoFim(caminho) as (typeof RAIZES)[number])
}

// O React Router marca a PRIMEIRA entrada da sessao com a chave 'default'.
// Nela nao ha para onde voltar: abrir o app direto num link fundo, ou apenas
// recarregar a pagina, jogaria a pessoa para FORA do app.
export function destinoDoVoltar(chaveDaRota: string): 'historico' | 'inicio' {
  return chaveDaRota === 'default' ? 'inicio' : 'historico'
}
